<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="relative" >
      <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header">
            <div>
              <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Reports</h2>
            </div>
            <div class="page_actions">
              <button v-if="activeUserInfo.roleId == 1" :disabled="list.length<=0" class="primary_btn export_btn" @click="getTicketsListForExport()">
                  <img src="@/assets/images/pages/export.png">
                    Export
                  </button>
              <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
                <span class="material-icons"> filter_list</span>Filters
              </button>
            </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
        <div
      ref="filterCard" 
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Status</label>
          <multiselect
            v-model="filterData.statusIds"
            :options="status_list"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Status(es) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Statuses Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
        </div>      
       <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Company</label>
          <multiselect
            v-model="filterData.companyIds"
            :options="companies"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
            @input="getCustomerList()"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Company(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Companies Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
        </div>
         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  >
        
          <label class="text-sm opacity-75">Users</label>
         
          <multiselect
            v-model="filterData.customerIds"
            :options="customerList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="Product"
            :multiple="true"
             @search-change="searchCustomerList"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect>
           
        </div>
         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" v-if="activeUserInfo.roleId == 2">
          <label class="text-sm opacity-75">Projects</label>
          <multiselect
            v-model="filterData.projectIds"
            :options="projects"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="project"
            :multiple="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Projects(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Projects Found</span>
          </multiselect>
          <!--<v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />-->
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Created Date</label>
          <date-range-picker :autoApply="autoApply" :ranges="false" :opens="'left'" :maxDate="maxDate"
           v-model="selected_createdDateRange" placeholder="Select Range"></date-range-picker>
        </div>
        

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Case Type</label>
                <multiselect
                  v-model="filterData.typeDetails"
                  :options="ticket_type"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="status"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case Type(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Case Types Found</span>
                </multiselect>
          
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
        <label class="text-sm opacity-75">Search</label>
          <input
           v-model="filterData.title"
            class="search_field" 
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Title"
          />
         <!--  @input="apply_filter(filterData)" -->
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
        
        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex align-end justify-end padt10 marb10">
           <button @click="clearFilters()" class="secondary_btn">
            Clear
          </button>
          <button class="primary_btn marl15" @click="apply_filter(filterData)">
            Apply
          </button>
        </div>        
      </div>
    </div>
      </div> 
                    
    
    
       
    <vs-table class="table_list"> 
      <template slot="thead">
        <vs-th>
            <span>
              <a
                @click="sortMe('customId')"
                v-bind:class="{
                  sort_ascending: sortKeys['customId'] == 1,
                  sort_descending: sortKeys['customId'] != 1,
                }"
                >Case ID</a
              >
            </span>
        </vs-th>
        
        <vs-th>
            <span>
              <a
                @click="sortMe('title')"
                v-bind:class="{
                  sort_ascending: sortKeys['title'] == 1,
                  sort_descending: sortKeys['title'] != 1,
                }"
                >Title</a
              >
            </span>
        </vs-th>
        
        <vs-th>
           <span>
              <a
                @click="sortMe('projectName')"
                v-bind:class="{
                  sort_ascending: sortKeys['projectName'] == 1,
                  sort_descending: sortKeys['projectName'] != 1,
                }"
                >Project</a
              >
            </span>
          
        </vs-th>
        <vs-th>
           Case Type
          
        </vs-th>
        
        <vs-th>
           <span>
              <a
                @click="sortMe('statusName')"
                v-bind:class="{
                  sort_ascending: sortKeys['statusName'] == 1,
                  sort_descending: sortKeys['statusName'] != 1,
                }"
                >Status</a
              >
            </span>
          
        </vs-th>
        
        <vs-th>
           <span>
              <a
                @click="sortMe('createdByName')"
                v-bind:class="{
                  sort_ascending: sortKeys['createdByName'] == 1,
                  sort_descending: sortKeys['createdByName'] != 1,
                }"
                >Created By</a
              >
            </span>
          
        </vs-th>
        <vs-th>
           <span>
              Company
            </span>
          
        </vs-th>
        <!-- <vs-th>Initial Response Time</vs-th>
         <vs-th>Overall Resolution Time</vs-th>-->

        <vs-th>

           <span>
              <a
                @click="sortMe('updatedOn')"
                v-bind:class="{
                  sort_ascending: sortKeys['updatedOn'] == 1,
                  sort_descending: sortKeys['updatedOn'] != 1,
                }"
                >Updated On</a
              >
            </span>
        </vs-th>
        
         <!--<vs-th v-if="activeUserInfo.roleId == 1">
          Assigned To
        </vs-th>
        <vs-th>
          Action
        </vs-th>-->
      </template>

      <template v-if="list && list.length > 0">
        <vs-tr v-for="(item, index) in list" :key="index"> 
          <vs-td>
           <router-link
                    :to="'/support-ticket-details/'+item['_id']"
                    > {{item.customId}}</router-link>
          </vs-td>

          <vs-td>
           <template v-if="item.title">
              <div class="description w-160" v-html="item.title" ></div>
           </template>
          
           </vs-td>
          <!-- <vs-td><span v-html="getDescription(item)" class="description"></span> </vs-td> -->
           <vs-td  class="w-160">
           <template v-if="checkProperty(item ,'projectDetails' ,'name')">
           {{
            
             checkProperty(item ,'projectDetails' ,'name')
             
             }} 
               </template>
          </vs-td>
            <vs-td>
            <!-- 
              {{item.createdOn | formatDate}}
               <br>
              <small>{{ item.createdOn | formatTime}}</small>   
              -->
                <template v-if="checkProperty(item ,'typeDetails' ,'name')" >
                {{checkProperty(item ,'typeDetails' ,'name')}}    
                </template>
               
          </vs-td>
          
          <vs-td >
            <span class="td_status" :class="{'new':item.statusId==1 , 'inprogress':item.statusId==2 , 'closed':item.statusId== 3 , 'rejected':item.statusId==4, 'defered':item.statusId==5}"
              >{{item['statusDetails']['name']}}
            </span> 
          </vs-td>
         
          <vs-td>
           {{ item.createdByDetails.name }}
          </vs-td>
           <vs-td>
              <template v-if="item.createdByDetails['companyDetails']"> 
                {{ item.createdByDetails['companyDetails'].name }}
             </template>
           <!-- {{ item.createdByDetails['companyDetails'].name }} -->
          </vs-td>

          <!--<vs-td>
       
            <template v-if="checkProperty( item ,'initResTime')">
                {{ checkProperty( item ,'initResTime')}}
            </template>
          </vs-td>

          <vs-td>
           
           <template v-if="checkProperty( item ,'overallResTime')">
            {{ checkProperty( item ,'overallResTime')}}
           </template>
          </vs-td>-->

          <vs-td> <span v-if="item.updatedOn">
              {{item.updatedOn | formatDate}}
              <br>
               <small>{{ item.updatedOn | formatTime}}</small>     
            </span>
            <!-- <span v-else> -
            </span> -->
          </vs-td>
          
        
        </vs-tr>
      </template>
        <template v-else>
          <tr v-if="!loading" >
            <td class="center-align" colspan="9">No Cases Found!</td>
          </tr>
        </template>
    </vs-table>
      <div class="pagination_wrap" v-if="totalPages > 0">
        <div class="pagination_content">
          <h6>Show Records</h6>
         <!--  <v-select
            @input="change_perPage()"
            v-model="perPage"
            :options="perPeges"
            label="Per Page"
            solo
          ></v-select> -->

          <multiselect
            :multiple="false" 
              @input="change_perPage()"
            placeholder="Page"
            
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="perPage" :options="perPeges" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              
            </multiselect>
        </div>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="page"
          @input="getList()"
        />
      </div>

    <vs-popup class="holamundo" :active.sync="popupcreateticket"  title="New Case">
      <div class="createticket_form form_section">

        <!--<template>
  <div id="app">
    <froala id="edit" :tag="'textarea'" :config="config" v-model="model"></froala>
  </div>
</template>-->

        <form autocomplete="off">
         <ul>
         <li>
              <div class="form-group">
              <label class="form_label">Subject</label>
              <vs-input
                v-validate="'required|min:3'"
                name="Subject"
                icon-no-border
                icon-pack="feather"
                 v-model="ticket.title"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("Subject")
              }}</span>
              </div>
            </li>
          
           <li>
             <div class="form-group">
             <label class="form_label">Description</label>
           
               <ckeditor :editor="editor" v-model="ticket.description" :config="editorConfig"></ckeditor>
                
                <span class="text-danger text-sm">{{
                errors.first("Description")
              }}</span>
             </div>
           </li>
            
            <li> 
              <div class="taggable">
                <div class="form-group">
               
                <label class="form_label">Project</label>
                  <multiselect 
                        v-model="ticket.selectedProject" 
                        :options="projects" 
                        :clear-on-select="false"
                        :hide-selected="false"
                        :preserve-search="true"
                       placeholder="Select Project"
                        label="name"
                        track-by="name"
                        id="project"
                          >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" 
                          v-if="values.length && !isOpen">{{ values.length }} Projects(s) selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                        <span slot="noResult">No Projects Found</span>
                  </multiselect>
                </div>
              </div>
            </li>
             <li>
              <div @click="documents=[]" class="files_wrap">
                    <file-upload v-model="documents" class="file-upload-input"
                    accept=""  :name="'files'" data-vv-as="Upload SDK files"
                      :multiple="true" @input="upload(documents)" >
                      <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                    </file-upload>
                    <span class="text-danger text-sm"
            v-show="errors.has('files')">{{ errors.first('files') }}</span>
            </div>
            <ul  class="uploaded-list">
             
             <li><vs-chip @click="remove(indx)" :name="'fileRemoveSelected'" 
             v-for="(other, indx) in ticket.documents" :key="indx"  closable> {{ other.name }} </vs-chip></li>
             
            </ul> 
            </li> 
        
           
         </ul>

        </form>
        <div class="form_actions">
           <!--<vs-upload multiple  automatic action="https://jsonplaceholder.typicode.com/posts/" />-->
           <span></span>
          <button class="close_popup primary_btn" 
          :disabled="!validateForm"
          @click="onSubmit()">Create</button>
        </div>
      </div>
      
    </vs-popup>

     <vs-popup class="holamundo" :active.sync="popupCreateProject"  title="New Project">
      <div class="createticket_form form_section">
        <form autocomplete="off">
          <ul>
            <li>
              <div class="form-group">
                <label class="form_label">Project Name</label>
                <vs-input
                  v-validate="'required|min:3'"
                 
                  name="Name"
                  icon-no-border
                  icon-pack="feather"
                  v-model="projectName"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Name")
                }}</span>
              </div>
            </li>
          </ul>
        </form>
        <div class="form_actions">
           <!--<vs-upload multiple  automatic action="https://jsonplaceholder.typicode.com/posts/" />-->
           <span></span>
          <button class="close_popup primary_btn" 
          :disabled="!validateProject"
          @click="onAddProject()">Create</button>
        </div>
      </div>
      
    </vs-popup>

    <vs-popup
        class="holamundo"
        :active.sync="popupAssignFlag"
        title="Assign Employees"
      >
        <div class="createticket_form">
          <form autocomplete="off">
          <ul>
            <li>
              <div class="form-group">
                <label class="form_label">Assign To</label>
                <multiselect
                  v-model="assignedTo" 
                  :options="employeeList"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true" 
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="assign"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                    
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Employee(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Employees Found</span>
                </multiselect>
              </div>
            </li>
          </ul>
        </form>
          <div class="form_actions">
            <span></span>
            <button class="close_popup primary_btn" 
              :disabled="!validateAssign"
              @click="onAssignEmployee()">
              Assign
            
            </button>
          </div>
        </div>
      </vs-popup>


  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import FileUpload from "vue-upload-component/src";
import Multiselect from 'vue-multiselect-inv';
import moment from "moment";

import _ from "lodash";
import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from '@/axios.js'

export default {
  components: { 
    //ClassicEditor,
    //CKEditor,
    vSelect,
    DateRangePicker,
    
    FileUpload,
    Multiselect
  },
   computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.ticket.description !== "" &&  this.ticket.title !== "" &&
        this.ticket.selectedProject !== null 
        //&& this.ticket.documents != ""
      );
    },
    activeUserInfo () {
      return this.$store.state.auth.user
    },
     validateProject() {
      return (
        !this.errors.any() &&
        this.projectName !== ""
      );
    },
    validateAssign() {
      return this.assignedTo.length > 0
    },
  },
  data:() => ({
    loading:true,
    filtersList: false,
    callFromSort:false,
    companies:[],
     customerList:[],
     searchCustomer:'',
    editor: ClassicEditor,
    editorConfig: {
        // The configuration of the editor.
        toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],
        
    },

    userdata:null,
    reportTo_obj:'',
    products: [],
    list: [],
    projects: [],
    ticket: {"description":'',"title":'',"selectedProject":''},
    sortKey: {},
    page: 1,
    perPage: 25,
    totalPages: 0,
    sortKeys: {},
    documents:[],
    status_list: [],
    selected_createdDateRange :{
      startDate: null,
      endDate: null
    },
    perPeges: [25, 50, 75, 100],
    stats : {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    },
    autoApply: "",
    config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }          
        },
        charCounterCount: false,
        //toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'outdent', 'indent', 'clearFormatting', 'insertTable', 'html'],
        toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline'],
        //toolbarButtonsXS: ['undo', 'redo' , '-', 'bold', 'italic', 'underline']
      },
      model: 'Edit Your Content Here!',
    filterText:'',  
    // filterData: {
    //   customerList:[],
    //   title: "",
    //   statusIds: [],
    //   productIds: [],
    //   productIds: [],
    //   projectIds: [],
    //   createdOnRange: [],
    //    companyIds:[],
    // },
    filterData: {
      
      title: "",
      statusIds: [],
      productIds: [],
      productIds: [],
      projectIds: [],
      customerIds: [],
      createdOnRange: [],
       companyIds:[],
       typeDetails:[]
    },
    ticket_type:[],
    
    maxDate: new Date(),
    userFilters: {
      title: "",
      statusIds: [],
      productIds: [],
      customerIds: [],
      projectIds: [],
      createdOnRange: [],
       companyIds:[],
    },
    projectName: '',
    popupCreateProject: false,
    assignedTo: [],
    employeeList: [],
    popupAssignFlag: false,
    ticketId: "",

    reportinglist: [
      { label: 'Internal Project', value: 'internal' },
      { label: 'Customer Project', value: 'customer' } 
    ],
    textarea: '',
    popupcreateticket:false,
    dateRange:'',
    statusFilter: { label: 'All', value: 'all' },
    statusOptions: [
      { label: 'All', value: 'all' },
      { label: 'New', value: 'new' },
      { label: 'In Progress', value: 'inProgress' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Defered', value: 'defered' },
      { label: 'Closed', value: 'closed' }
    ],
    emailFilter: { label: 'All', value: 'all' },
    emailOptions: [
      { label: 'All', value: 'all' },
      { label: 'user@yopmail.com', value: 'user' },
      { label: 'admin@yopmail.com', value: 'admin' } 
    ],
      
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0,

    searchQuery: '',
    exportData:null,
    

    ////////////
     
  }),
  methods:{ 
    getTicket_type(category ="ticket_type"){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: category
      }
      this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
      this[category] = response;
     
    });

    },
    checkProperty(obj ,key='' ,subKye=''){
      
      if(_.has(obj , key)){
         //alert(key+" ---"+subKye)
        if(obj[key]){
          if(subKye==''){
            return obj[key];
          }else{

            if(_.has(obj[key] , subKye)){
              if(obj[key][subKye]){
                 return obj[key][subKye];
              }else{
                 return false;
              }

            }else{
              return false;
            }
          }
          
        }else{
          return false;
        }
     

      }else{
        return false;
      }

    }, 

    getDescription(sdk){
      let hrml  = sdk.description;
      let str = hrml.replace(/<[^>]*>/g, '');
      return str.substring(0, 15);
    },

    // @search-change="searchCustomerList"
    searchCustomerList(val=''){
      this.searchCustomer = val;
      this.getCustomerList();
    },
    getCustomerList() {
    
      let postData =  {
        "matcher": {
            "searchString": this.searchCustomer,
            "companyIds": []
        },
        "page": 1,
        "perpage": 1000,
        "category": "cusomers_by_login_user"
    }
      if(this.filterData.companyIds && this.filterData.companyIds.length>0){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['matcher']['companyIds'].push(obj['_id']);
         });
     }

      this.customerList = [];
      this.$store
        .dispatch("getMasterData", postData)
        .then((response) => {
          let customers = response.list;
          _.forEach(customers ,(item)=>{
            if(_.has(item ,"name") && _.has(item ,"email") ){
              item['name'] = item['name'] +" ( "+item['email']+" )"
              this.customerList.push(item);

            }else{
              this.customerList.push(item);
            }
           

          });
         
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });
    },
    gotopage () {
      alert('test')
    },
    addProject (newTag) {
      this.reportinglist.push( 
        { 'label':newTag, 'value':newTag} 
      )
    },
     change_perPage() {
      this.page = 1;
      this.getList();
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
     setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    openCreatePop() {
      this.errors.clear();
      this.init();
      this.popupcreateticket = true;
     
     // this.updateUserKey();
    },
    openProjectPop() {
      this.projectName = ""
      this.errors.clear();
      this.popupCreateProject = true;
    },
     init() {
      this.errors.clear() 
      this.ticket = {
        description: "",
        selectedProject:null,
        productId: "",
        documents: [],
        projectId: "",
        today: moment().format("YYYY-MM-DD")
      };
    },
    onEnter() {
      this.filtersList =false;
      this.getList();
    },
    getList() {
      //customerList
      let postData = {
        filters:{"title": this.filterData.title,	"projectIds": [],	"productIds": [],	"statusIds": [] ,	"customerIds": [],	"companyIds": [] ,"createdOnRange":[] ,"typeIds":[]},
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
       if(this.filterData.projectIds.length>0){
        for( let i=0; i<this.filterData.projectIds.length;i++){
          postData.filters.projectIds.push(this.filterData.projectIds[i]['_id'] )
        }
      }
       if(this.filterData.customerIds.length>0){
        for( let i=0; i<this.filterData.customerIds.length;i++){
          postData.filters.customerIds.push(this.filterData.customerIds[i]['_id'] )
        }
      }
       if(this.filterData.companyIds.length>0){
        for( let i=0; i<this.filterData.companyIds.length;i++){
          postData.filters.companyIds.push(this.filterData.companyIds[i]['_id'] )
        }
      }
      if(this.filterData.productIds.length>0){
        for( let i=0; i<this.filterData.productIds.length;i++){
          postData.filters.productIds.push(this.filterData.productIds[i]['_id'] )
        }
      }
      if(this.filterData.statusIds.length>0){
        for( let i=0; i<this.filterData.statusIds.length;i++){
          postData.filters.statusIds.push(this.filterData.statusIds[i]['_id'] )
        }
      }
      
      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }
     
      if(!this.callFromSort){
         this.list = [];
      }
      this.callFromSort =false;

      if(this.filterData.typeDetails.length>0){
        for( let i=0; i<this.filterData.typeDetails.length;i++){
          postData.filters.typeIds.push(this.filterData.typeDetails[i]['_id'] )
        }
      }
      this.$vs.loading()
     this.loading =true;
      this.$store
        .dispatch("getTicketList", postData)
        .then((response) => {
          this.list = response.list;
          this.totalPages = Math.ceil(response.totalCount / this.perPage);
            this.list.forEach((item) => {
            if (item.assignEmpDetails && item.assignEmpDetails.length > 0) {
              let arr = [];
              item.assignEmpDetails.forEach((item2) => {
                arr = item2.name.split(" ");
                if (arr.length > 1) {
                  item2.shortName = arr[0].charAt(0).concat(arr[1].charAt(0));
                } else if (arr.length == 1) {
                  item2.shortName = arr[0].slice(0, 2);
                }
              });
            }
             this.loading =false;
             this.$vs.loading.close();
          });
        })
        .catch((err) => {
          console.log(err);
          this.loading =false;
          this.$vs.loading.close();
        });
    },
    getTicketsListForExport() {
      let APIURL = axios.defaults['baseURL'];
      let postData = {
        filters:{"title": this.filterData.title,	"projectIds": [],	"productIds": [],	"statusIds": [] ,	"customerIds": [],	"companyIds": [] ,"createdOnRange":[], "typeIds":[]},
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
       if(this.filterData.projectIds.length>0){
        for( let i=0; i<this.filterData.projectIds.length;i++){
          postData.filters.projectIds.push(this.filterData.projectIds[i]['_id'] )
        }
      }
       if(this.filterData.customerIds.length>0){
        for( let i=0; i<this.filterData.customerIds.length;i++){
          postData.filters.customerIds.push(this.filterData.customerIds[i]['_id'] )
        }
      }
       if(this.filterData.companyIds.length>0){
        for( let i=0; i<this.filterData.companyIds.length;i++){
          postData.filters.companyIds.push(this.filterData.companyIds[i]['_id'] )
        }
      }
      if(this.filterData.productIds.length>0){
        for( let i=0; i<this.filterData.productIds.length;i++){
          postData.filters.productIds.push(this.filterData.productIds[i]['_id'] )
        }
      }
      if(this.filterData.statusIds.length>0){
        for( let i=0; i<this.filterData.statusIds.length;i++){
          postData.filters.statusIds.push(this.filterData.statusIds[i]['_id'] )
        }
      }
      
      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }
     
       if(this.filterData.typeDetails.length>0){
        for( let i=0; i<this.filterData.typeDetails.length;i++){
          postData.filters.typeIds.push(this.filterData.typeDetails[i]['_id'] )
        }
      }
         
      this.$store
        .dispatch("getTicketsListForExport", postData)
        .then((response) => {
         
          this.exportData = response;
           //alert(JSON.stringify(APIURL+this.exportData['path']));
          
           window.open(APIURL+"/viewfile?path="+this.exportData['path'], "_blank");
           //viewfile?path=

          
        })
        .catch((error) => {
           this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
        });
    },
    sortMe(sort_key = "") {
      
      this.sortKey = { path: "createdOn", order: 1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        this.getList()
      }
    },
    upload(model){
     
          let temp_count = 0;
          let formData = new FormData();                    
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  url:item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
              if (mapper.length > 0) {
                this.$vs.loading();
              mapper.forEach((doc, index) => {
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                   
                      response.data.result.forEach(urlGenerated => {
                          if(_.has(urlGenerated ,"path") && !( _.has(urlGenerated ,"url"))){
                              urlGenerated['url'] = urlGenerated ['path'];
                              
                          }
                           if(_.has(urlGenerated ,"url") && !( _.has(urlGenerated ,"path")) ){
                              urlGenerated['path'] = urlGenerated ['url'];
                              
                          }
                          this.ticket.documents.push(urlGenerated)                       
                               
                          if (temp_count >= mapper.length) {
                               
                             this.documents=[];
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
            
      
    },
    remove(index){
      this.ticket.documents.splice(index ,1);
    },
    onSubmit() {
      this.ticket.projectId = this.ticket.selectedProject['_id'];
      //alert(this.ticket.selectedProject['_id']);

      this.$vs.loading();
      this.$store
        .dispatch("supportTicketCreate", this.ticket)
        .then((res) => {
          this.popupcreateticket = false;
          // this.updateUserKey();
          this.getList();
          this.getDashboardStats();
          this.$vs.loading.close();
          this.init();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    apply_filter(data) {
      this.filterData = data;
      this.page = 1;
      
       this.filtersList =false;
  
      this.getList();
    },
    onAddProject() {
      const payload = {
        name: this.projectName,
      };
      payload.category = 'project'
      this.$vs.loading();
      this.$store
        .dispatch("projectCreate", payload)
        .then((res) => {
          this.popupCreateProject = false;
          this.projectName = "";
          this.getProjectList();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
    },
    getProjectList() {
        this.$store.dispatch("getProjects").then((response) => {
        this.projects = response;
      });
    },
    openAssignPopup(item) {
      this.ticketId = item._id;
      this.assignedTo = [];
        if (item.assignEmpDetails && item.assignEmpDetails.length > 0) {
            this.assignedTo = item.assignEmpDetails;
        } else {
          this.assignedTo = []
        } 
      this.popupAssignFlag = true;
    },
    onAssignEmployee() {
      this.assignedTo = this.assignedTo.map(item => item._id);
      const payload = {
        ticketId: this.ticketId,
        assignedTo: this.assignedTo
      };
     this.$vs.loading();
      this.$store
        .dispatch("assignEmployees", payload)
        .then((res) => {
          this.popupAssignFlag = false;
          this.getList()
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
     },
     getDashboardStats() {
      let postData = {};
      this.$store
        .dispatch("getTicketStats", postData)
        .then((response) => {
          _.forEach(response ,(object ,index) => {
            this.stats[object.statusId] = object.count;
         })
        })
        .catch((err) => {
          console.log(err);
        });
    },
     clearFilters() {
        this.filtersList =false;
        this.customerList =[];
       this.filterData = {
        title: "",
        statusIds: [],
        productIds: [],
        productIds: [],
        projectIds: [],
        createdOnRange: [],
        companyIds:[],
        customerIds: [],
        typeDetails:[],
        
      }

      
      this.selected_createdDateRange  = {
        startDate: null,
        endDate: null
      },
      this.getCustomerList();
      this.getList();
    }
  },
  mounted() {
    this.getTicket_type();
     this.userdata = this.$store.state.auth.user;
     
    this.$store.dispatch("getProducts").then((response) => {
      this.products = response;
    });
    this.$store.dispatch("getTicketStatus").then((response) => {
      this.status_list = response;
    });
    this.$store.dispatch("getEmployeeList").then((response) => {
     
      this.employeeList = response;
      this.employeeList.forEach(item => {
        item.name = item.name + '('+item.roleName +')'
      })
      //this.employeeList = this.employeeList.map(item => item.name.concat(item.roleName))
    });
    this.$store.dispatch("getCompanies").then((response) => {
          this.companies = response;
        });

    this.getProjectList();
    this.getCustomerList();
    this.sortKeys = {
      customId: 1,
      statusName: 1,
      createdOn: -1,
      createdByName: 1,
      projectName: 1,
      updatedOn: -1
    };


    this.getList();
    this.getDashboardStats();
  },
  watch:{
    popupAssignFlag:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupCreateProject:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    }
 
  }


}
</script>
<style  lang="scss">

.con-expand-users {
  .con-btns-user {
        display: flex;
        padding: 10px;
        padding-bottom: 0px;
        align-items: center;
        justify-content: space-between;
        .con-userx {
        display: flex;
        align-items: center;
        justify-content :flex-start;
            .list-icon {
                i{ font-size: .9rem !important;}
            }
        }
    }
}
.not-data-table  {display:none;}
 
.multiselect .multiselect__content-wrapper ul li .multiselect__option:after {    display: inline-block !important;
    content: attr(data-select);
    background: #41b883;    position: absolute;
    right: 5px;padding: 0 10px;
    color: #fff;}
</style>